import React from 'react'
import "./Footer.css"

function Footer() {
    return (
        <div className="footer">
            <p>Airbnb Clone! THIS IS ONLY A DEMO</p>
            <p>2021 </p>
        </div>
    )
}

export default Footer
